import React, { useEffect, useRef, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import ReactSelect from "react-select";
import InputBox from "../InputBox";
import TextArea from "../TextArea";
import NoramlButton from "../Button";
import { uploadCRMFile } from "../API/api";
import { Toast } from "service/toast";
const { Modal } = require("react-bootstrap");

export const DynamicFormModal = ({
  show,
  onClose,
  onSave,
  onCreate,
  formFields,
  initialData,
  isEdit = false,
}) => {


  console.log(initialData, "initialData")
  const defaultValues = formFields.reduce((acc, f) => {
    if (f.component === "CommonSelect") {
      acc[f.name] = f.isMulti ? [] : null;
    } else {
      acc[f.name] = "";
    }
    return acc;
  }, {});

  const {
    register,
    handleSubmit,
    control,
    setValue,
    formState: { errors },
    reset,
    watch,
    getValues
  } = useForm({ defaultValues, mode: "onChange" });

  const customStyles = {
    control: (base) => ({
      ...base,
      height: 38,
      minHeight: 38,
      width: "250",
    }),

    valueContainer: (provided, state) => ({
      ...provided,
      height: "30px",
      padding: "10",
      width: "250"
    }),
  }
  const [dynamicOptions, setDynamicOptions] = useState({});
  const hiddenFileInput = useRef(null);
  const [selectedFile, setSelectedFile] = useState(null);

  useEffect(() => {
    const fetchAllAsyncOptions = async () => {
      const optionsMap = {};
      for (const field of formFields) {
        if (typeof field.options === "function") {
          try {
            const opts = await field.options();
            optionsMap[field.name] = opts;
          } catch (error) {
            console.error(`Failed to fetch options for ${field.name}:`, error);
            optionsMap[field.name] = [];
          }
        }
      }
      setDynamicOptions(optionsMap);
    };
    fetchAllAsyncOptions();
  }, [formFields]);

  const watchedFields = watch(["status", "skillName", "zendeskGroupId", "priority", "toTime", "fromTime", "campRunTime", "prioritylevel"]);

  console.log(watchedFields, "watchfields")
  useEffect(() => {
    const resetValues = {};

    formFields.forEach((field) => {
      if (field.component === "CommonSelect") {
        resetValues[field.name] = field.isMulti ? [] : null;
      } else {
        resetValues[field.name] = "";
      }

      if (field.defaultValue !== undefined) {
        resetValues[field.name] = field.defaultValue;
      }
    });

    if (initialData) {
      formFields.forEach((field) => {
        let value = initialData[field.name];

        if (field.name === "zendeskGroupId" && value && typeof value === "object") {
          value = value._id;
        }

        if (field.component === "CommonSelect") {
          const options = Array.isArray(field.options)
            ? field.options
            : dynamicOptions[field.name] || [];

          if (Array.isArray(value)) {
            resetValues[field.name] = options.filter((opt) =>
              value.includes(opt.value) || value.includes(opt.label)
            );
          } else {
            resetValues[field.name] =
              options.find((opt) => opt.value === value || opt.label === value) || null;
          }
        } else {
          resetValues[field.name] = value ?? "";
        }
      });
    }

    reset(resetValues);
  }, [initialData, formFields, reset, dynamicOptions]);

  const onSubmit = async (data) => {
    const finalData = { ...data };

    formFields.forEach((field) => {
      if (field.component === "CommonSelect") {
        const raw = data[field.name];
        if (field.isMulti) {
          finalData[field.name] = Array.isArray(raw)
            ? raw.map((item) => field.returnObject ? item?.label : item?.value)
            : [];
        } else {
          finalData[field.name] = field.returnObject
            ? raw
            : raw?.value ?? raw?.label ?? raw ?? null;
        }
      }
    });

    const hasFileUpload = formFields.some((f) => f.component === "FileUpload");

    if (hasFileUpload) {
      const values = getValues();
      const campaignName = values.campaignName;

      if (!selectedFile) {
        Toast({ type: 'error', message: 'Please select a file to upload' })
        return;
      }

      if (!campaignName) {
        Toast({ type: 'error', message: 'Please enter a campaign name' })
        return;
      }

      const formData = new FormData();
      formData.append("file", selectedFile);
      formData.append("campaignName", campaignName);

      try {
        const response = await uploadCRMFile(formData);
        onClose();
      } catch (error) {
        console.error("Upload failed", error);
        Toast({ type: 'error', message: 'File upload failed' })
      }
      return;
    }

    const output = isEdit && initialData?._id
      ? { ...finalData, _id: initialData._id }
      : finalData;
    isEdit ? onSave(output) : onCreate(output);
  };

  const handleClick = () => {
    hiddenFileInput.current.click();
  }

  return (
    <Modal show={show} onHide={onClose} backdrop="static">
      <Modal.Header closeButton>
        <Modal.Title>{initialData ? "Edit" : "Add"} Record</Modal.Title>
      </Modal.Header>

      <form onSubmit={handleSubmit(onSubmit)} noValidate>
        <Modal.Body>
          {formFields.map((field) => {

            if (!field?.name || !field?.component) {
              console.warn("Skipping invalid field config:", field);
              return null;
            }
            /* ───────── Text / number inputs ───────── */
            if (field.component === "InputBox") {
              return (
                <InputBox
                  key={field.name}
                  type={field.type || "text"}
                  name={field.name}
                  label={field.label}
                  register={register(field.validation)}
                  error={errors?.[field.name]}
                  messages={field.messages}
                  disabled={field.disabled}
                />
              );
            }

            if (field.component === "CommonSelect") {
              const options = Array.isArray(field.options)
                ? field.options
                : dynamicOptions[field.name] || [];

              const isMulti = field.isMulti || false

              const value = watchedFields[field.name];

              return (
                <div key={field.name} className="mb-3">
                  <label>{field.label}</label>
                  <Controller
                    name={field.name}
                    control={control}
                    rules={field.validation}
                    render={({ onChange }) => (
                      <ReactSelect
                        inputId={field.name}
                        options={options}
                        styles={customStyles}
                        placeholder={`Select ${field.label}`}
                        getOptionLabel={(e) => e?.label}
                        getOptionValue={(e) => e?.value}
                        isClearable={true}
                        isMulti={isMulti}
                        value={value}
                        onChange={onChange}
                      />
                    )}
                  />
                  {errors[field.name] && (
                    <p className="text-danger mt-1 small">
                      {field?.messages?.required || "This field is required"}
                    </p>
                  )}
                </div>
              );
            }

            if (field.component === "TextArea") {
              return (
                <TextArea
                  key={field.name}
                  name={field.name}
                  label={field.label}
                  register={register(field.validation)}
                  placeholder="Enter here"
                  rows={field.rows || 3}
                  error={errors?.[field.name]}
                  messages={field.messages}
                  disabled={field.disabled}
                />
              );
            }

            if (field.component === "FileUpload") {
              return (
                <div key={field.name} className="mb-3">
                  <label className="form-label">{field.label}</label>
                  <Controller
                    name={field.name}
                    control={control}
                    rules={field.validation}
                    render={({ onChange }) => (
                      <>
                        <input
                          type="file"
                          ref={hiddenFileInput}
                          style={{ display: "none" }}
                          onChange={(e) => {
                            const file = e.target.files[0];
                            onChange(file);
                            setSelectedFile(file);
                          }}
                        />
                        <NoramlButton type="button" className="addBtn" onClick={handleClick}>
                          Upload File
                        </NoramlButton>
                        {watch(field.name)?.name && (
                          <p className="mt-2 small">
                            Selected: <strong>{watch(field.name).name}</strong>
                          </p>
                        )}
                      </>
                    )}
                  />
                  {errors[field.name] && (
                    <p className="text-danger mt-1 small">
                      {field?.messages?.required || "This field is required"}
                    </p>
                  )}
                </div>
              );
            }

            return null;
          })}
        </Modal.Body>

        <Modal.Footer>
          <button type="button" className="btn btn-secondary" onClick={onClose}>
            Cancel
          </button>
          <button type="submit" className="btn btn-success">
            {initialData ? "Update" : "Add"}
          </button>
        </Modal.Footer>
      </form>
    </Modal>
  );
};
